import { ROUTER_PATHS } from '../../../../../navigation/routerPaths';
import { FieldKeys } from '../types/fieldKeys';

export const OnboardingFileKeys = [
    {
        [ROUTER_PATHS.personalInformation]: [
            FieldKeys.abroadAddress,
            FieldKeys.maritalStatus,
            FieldKeys.swissAddress,
            FieldKeys.expensesForOptimization,
            FieldKeys.mealAllowance,
            FieldKeys.representativeAllowance,
            FieldKeys.cba,
            FieldKeys.lossOfIncome,
            FieldKeys.accidentRate,
            FieldKeys.otherJob,
            FieldKeys.workTime,
            FieldKeys.paymentCurrency,
            FieldKeys.treasury,
        ],
    },
    {
        [ROUTER_PATHS.bankAccount]: [FieldKeys.bankAccount],
    },
    {
        [ROUTER_PATHS.workContract]: [FieldKeys.workTimeContract, FieldKeys.invoiceCurrency],
    },
    {
        [ROUTER_PATHS.workPermit]: [FieldKeys.workPermit],
    },
];
